export default {
  interviewer: state => state.interviewer,
  interviewerCount: state => state.interviewer.map(item => item).filter(item => item.state === 0).length,
  errors: state => state.errors
};
